export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL';

export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const REMOVE_SELECTED_PRODUCT = 'REMOVE_SELECTED_PRODUCT';